export const convertImageUrlToBlob = async (imageUrl: string) => {
  try {
    const fetchObject = await fetch(imageUrl)
    return await fetchObject.blob()
  } catch {
    return undefined
  }
}
